export const RECOMMENDATIONS_MICROFRONTEND_NAME = 'recommendations-micro-frontend';

export const RECOMMENTATIONS_MICROFRONTEND_PATH = '/v1/desktop/get-recommendations-micro-frontend/';
